import { useCallback } from "react";
import Swal from "sweetalert2";
import {
    DESIGNER_ACTIONS,
    buildDefaultSelectedKeys,
    getWizardPartNodes,
} from "../../utils/designerState";

const useDesignerResetFlow = ({
    normalizedRoot,
    treeContext,
    draftStorageKey,
    dispatch,
    setCurrentStep,
    setSaveMsg,
    setSketchImage,
    setSketchError,
    setSideConfirm,
    setPrintHotspotFilter,
    setShowPrintHotspots,
}) => useCallback(async () => {
    if (!normalizedRoot) return;
    const result = await Swal.fire({
        icon: "warning",
        title: "Resetear diseño",
        text: "¿Seguro querés resetear el diseño? Se perderá el borrador local.",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Sí, resetear",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#0071ce",
        cancelButtonColor: "#d54ab7",
    });
    if (!result.isConfirmed) return;
    const defaults = buildDefaultSelectedKeys(normalizedRoot, treeContext);
    const wizardParts = getWizardPartNodes({
        root: normalizedRoot,
        context: treeContext,
        selectedKeys: defaults,
    });
    const firstPart = wizardParts.find((part) => defaults.has(part.key))?.key || wizardParts[0]?.key || null;
    dispatch({
        type: DESIGNER_ACTIONS.INIT,
        selectedKeys: defaults,
        activePartKey: firstPart,
        viewSide: "front",
    });
    setCurrentStep(1);
    setSaveMsg(null);
    setSketchImage(null);
    setSketchError(null);
    setSideConfirm(null);
    setPrintHotspotFilter(null);
    setShowPrintHotspots(false);
    if (typeof window !== "undefined") {
        window.localStorage.removeItem(draftStorageKey);
    }
}, [
    normalizedRoot,
    treeContext,
    draftStorageKey,
    dispatch,
    setCurrentStep,
    setSaveMsg,
    setSketchImage,
    setSketchError,
    setSideConfirm,
    setPrintHotspotFilter,
    setShowPrintHotspots,
]);

export default useDesignerResetFlow;
